import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { ApplicationPath } from '../types/application-path.types';
import { ecgSelector } from '../selectors/ecg.selectors';

export const useApplicationNavigation = () => {
  const ecg = useSelector(ecgSelector);
  const navigate = useNavigate();

  return (path: ApplicationPath) =>
    navigate(`/${ecg.ecgId}/${path}`, { replace: false });
};
